import styled from 'styled-components';

import { SectionHeading, SectionSub } from './section';

export { SectionHeading, SectionSub };

const MOBILE = '@media (max-width: 768px)';

export const TestimonialsBg = styled.section`
  padding: 5.6rem 0;

  @media (max-width: 768px) {
    padding: 3.2rem 0;
  }
`;

export const TestimonialsInner = styled.div`
  max-width: 96rem;
  margin: 0 auto;
  padding: ${({ theme }) => `0 ${theme.spacing.lg}`};
`;

export const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing.lg};

  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

export const TestimonialCard = styled.div`
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border-radius: 1.6rem;
  padding: ${({ theme }) => theme.spacing.xl};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    transform: translateY(-0.4rem);
    box-shadow: 0 1.6rem 4rem rgba(15, 23, 42, 0.12);
    border-color: ${({ theme }) => theme.colors.accentBorder};
  }
`;

export const Avatar = styled.div<{ $bg: string; $color: string }>`
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 50%;
  background-color: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 700;
  flex-shrink: 0;
  letter-spacing: 0.05rem;
`;

export const TestimonialAuthorRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const TestimonialQuote = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.darkSlate};
  line-height: 1.6;
  font-style: italic;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const TestimonialHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const TestimonialFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TestimonialAuthor = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const TestimonialName = styled.span`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const TestimonialMeta = styled.span`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const VerifiedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.successText};
  background-color: ${({ theme }) => theme.colors.successBgSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.successBorder};
  border-radius: 999rem;
  padding: 0.3rem 0.8rem;
  letter-spacing: 0.02rem;
`;
